/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
import {
 Box,
 Checkbox,
 FormControl,
 FormControlLabel,
 InputLabel,
 MenuItem,
 Select,
 TextField,
 Theme,
 Typography,
 useTheme,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { StructureType } from '../../../types/types';
import { isJson } from '../../../utils/dataTypes';
import SelectApi from '../SelectApi';
import { useTranslation } from 'react-i18next';
import { usePage } from '../../../contexts/usePageContext';
const boxStyles = {
 display: 'flex',
 flexDirection: 'column',
 gap: 2,
};

type GroupedFields = StructureType & {
 Key: string;
 Translation: string;
 Group: string;
};

const EditFields = ({
 fieldsWithData,
 activeTabName,
}: {
 fieldsWithData: GroupedFields[];
 activeTabName?: string;
}) => {
 const {
  control,
  formState: { errors },
  setValue,
 } = useFormContext();
 const { t } = useTranslation();
 const th = useTheme();
 const { pageName } = usePage();
 const inputStyles = {
  backgroundColor: th.palette.kemek.white,
  '& .MuiInputBase-root': {
   backgroundColor: th.palette.kemek.white,
   height: 44,
  },
  '& .MuiInputBase-input': {
   p: '12px',
  },
  '.css-1r09j56-MuiFormControl-root-MuiTextField-root .MuiInputBase-root': {
   backgroundColor: th.palette.kemek.white,
   height: 44,
  },
  '& .MuiFormLabel-root': {
   transform: 'translate(14px, 12px) scale(1)',
   '&.MuiFormLabel-filled': {
    transform: 'translate(14px, -9px) scale(0.75)',
   },
   '&.Mui-focused': {
    transform: 'translate(14px, -9px) scale(0.75)',
   },
  },
 };

 const groups = useMemo(() => {
  const showEmptyGroup = false;
  const sortedFields =
   pageName === 'results'
    ? fieldsWithData || []
    : fieldsWithData?.sort((a, b) => a.Priority - b.Priority) || [];
  const groupedByTab: Record<string, Record<string, GroupedFields[]>> = {};
  const regularGroups: Record<string, GroupedFields[]> = {};

  sortedFields.forEach((f) => {
   if (!showEmptyGroup && f.Group === null) {
    return;
   }
   const normalizedGroup =
    pageName === 'results' ? '' : f.Group === null ? 'EMPTY GROUP!' : f.Group;
   const groupPattern = /^(.+?)_(.+)$/;
   const match = normalizedGroup?.match(groupPattern);

   if (match) {
    const [, tabName, groupName] = match;
    if (!groupedByTab[tabName]) {
     groupedByTab[tabName] = {};
    }
    if (!groupedByTab[tabName][groupName]) {
     groupedByTab[tabName][groupName] = [];
    }
    groupedByTab[tabName][groupName].push(f);
   } else {
    regularGroups[normalizedGroup] = regularGroups[normalizedGroup] || [];
    regularGroups[normalizedGroup].push(f);
   }
  });

  if (activeTabName && groupedByTab[activeTabName]) {
   return {
    groups: {},
    tabs: { [activeTabName]: groupedByTab[activeTabName] },
   };
  }

  return { groups: regularGroups, tabs: groupedByTab };
 }, [fieldsWithData, activeTabName, pageName]);

 const renderFields = (fields: GroupedFields[]) => {
  return fields?.map((f) => {
   //  if (!f.IsEditable) return false;

   if (f.Name === 'ResultProducts' || f.Type === 'array') {
    return false;
   }
   if (f.Type === 'model') {
    //    console.log(itemKey, val);
    return f.ForeignKeyUrl ? (
     <Box key={`${f.Key}`}>
      {f.ForeignKeyUrl !== 'not supported' ? (
       <SelectApi
        name={f.Name}
        url={f.ForeignKeyUrl}
        filter={f.ForeignKeyDefaultFilter}
        label={f.Translation}
        isEditable
        styles={inputStyles}
        operator={
         ['int32', 'decimal', 'double'].includes(
          f.InnerStructure.find(
           (s) =>
            s.Name ===
            (isJson(f.ForeignKeyDefaultFilter || '')
             ? JSON.parse(f.ForeignKeyDefaultFilter || '{}')?.fields.split(
                ',',
               )[1]
             : 'Name'),
          )?.Type || 'string',
         )
          ? 'eq'
          : 'contains'
        }
        control={control}
        setValue={setValue}
       />
      ) : (
       <Box key={`${f.Key}`}>{f.Name} ForeignKeyUrl not supported</Box>
      )}
     </Box>
    ) : (
     <Box
      sx={{
       ...boxStyles,
       color: (theme: Theme) => theme.palette.kemek.red,
      }}
      key={`${f.Key}`}
     >
      ForeignKeyUrl not found
     </Box>
    );
   }
   if (f.Type === 'datetime') {
    return (
     <Controller
      key={`${f.Key}`}
      name={f.Key}
      control={control}
      disabled={!f.IsEditable}
      render={({ field }) => {
       return (
        <DateTimePicker
         views={['year', 'month', 'day', 'hours', 'minutes']}
         sx={inputStyles}
         defaultValue={field.value === undefined ? null : dayjs(field.value)}
         {...field}
         value={field.value === undefined ? null : dayjs(field.value)}
         label={f.Translation}
        />
       );
      }}
     />
    );
   }
   //  if (f.Type === 'array') {
   //   return (
   //    <Box sx={boxStyles} key={`${f.Key}`}>
   //     <Typography sx={{ fontWeight: '600', fontSize: 20 }}>
   //      array select here {f.Name}
   //     </Typography>
   //    </Box>
   //   );
   //  }
   if (f.Type === 'boolean') {
    return (
     <Controller
      key={`${f.Key}`}
      name={f.Key}
      control={control}
      render={({ field }) => (
       <FormControlLabel
        control={
         <Checkbox
          {...field}
          checked={field.value || false}
          onChange={(e) => field.onChange(e.target.checked)}
         />
        }
        label={f.Translation}
       />
      )}
     />
    );
   }
   if (f.Type === 'enum') {
    return (
     <FormControl key={`${f.Key}`}>
      <InputLabel htmlFor={f.Name}>{f.Translation}</InputLabel>
      <Controller
       name={f.Name}
       control={control}
       render={({ field }) => {
        //    console.log(field.value);
        return (
         <Select
          sx={inputStyles}
          {...field}
          id={f.Name}
          onChange={(e: any, value: any) => {
           setValue(f.Name, f.EnumValues[e.target.value] || '', {
            shouldValidate: true,
           });
          }}
          value={
           Object.keys(f.EnumValues).find(
            (key) => f.EnumValues[key] === field.value,
           ) || ''
          }
          label={f.Translation}
          //  displayEmpty
         >
          {Object.entries(f.EnumValues).map(([value, label]) => (
           <MenuItem key={value} value={value}>
            {label}
           </MenuItem>
          ))}
         </Select>
        );
       }}
      />
     </FormControl>
    );
   }
   return (
    <Controller
     key={`${f.Key}`}
     name={f.Key}
     control={control}
     defaultValue=""
     render={({ field }) => (
      <TextField
       sx={inputStyles}
       {...field}
       value={field.value || ''}
       label={f.Translation}
       variant="outlined"
       error={!!errors?.[f.Key]}
       fullWidth
      />
     )}
    />
   );
  });
 };

 //  console.log('groups', groups);
 return (
  <Box>
   {Object.entries(groups.groups).map(([group, fields]) => (
    <Box key={group}>
     <Typography
      sx={{
       color: (theme: Theme) => theme.palette.kemek.darkGray,
       fontWeight: 500,
       fontSize: 14,
       mb: 2,
      }}
     >
      {group}
     </Typography>
     <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', mb: 2 }}>
      {renderFields(fields)}
     </Box>
    </Box>
   ))}
   {Object.entries(groups.tabs).map(([tabName, tabGroups], index) => (
    <Box key={tabName}>
     <Typography
      sx={{
       color: (theme: Theme) => theme.palette.kemek.darkGray,
       fontWeight: 600,
       fontSize: 16,
       mb: 2,
       mt: index === 0 ? 0 : 3,
      }}
     >
      {tabName}
     </Typography>
     {Object.entries(tabGroups).map(([groupName, fields]) => (
      <Box key={`${tabName}_${groupName}`}>
       <Typography
        sx={{
         color: (theme: Theme) => theme.palette.kemek.darkGray,
         fontWeight: 500,
         fontSize: 14,
         mb: 2,
        }}
       >
        {groupName}
       </Typography>
       <Box
        sx={{ display: 'flex', flexDirection: 'column', gap: '12px', mb: 2 }}
       >
        {renderFields(fields)}
       </Box>
      </Box>
     ))}
    </Box>
   ))}
  </Box>
 );
};

EditFields.displayName = 'EditFields';
export default EditFields;

